import type { RootState } from "@src/store/rootState";
import { getAnalyticsProductsLocation } from "@src/store/slices/analyticsProducts";
import { getExperienceProductsLocation } from "@src/store/slices/experienceProducts";

export const getProductsLocation = (state: RootState) => {
  return (
    getExperienceProductsLocation(state) ?? getAnalyticsProductsLocation(state)
  );
};
